import { render, staticRenderFns } from "./ThanksSinglePlus.vue?vue&type=template&id=f6ea0b52"
import script from "./ThanksSinglePlus.vue?vue&type=script&lang=js"
export * from "./ThanksSinglePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports